"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartErrorsToJSON = exports.CartErrorsFromJSONTyped = exports.CartErrorsFromJSON = exports.instanceOfCartErrors = exports.CartErrorsValidationCodeEnum = exports.CartErrorsErrorSubTypesEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.CartErrorsErrorSubTypesEnum = {
    _22Q112DigeorgeUnsupported: '22Q112_DIGEORGE_UNSUPPORTED',
    AllMicrodeletionsAddOnsRequired: 'ALL_MICRODELETIONS_ADD_ONS_REQUIRED',
    FetalSexAddOnDisallowedSingleton: 'FETAL_SEX_ADD_ON_DISALLOWED_SINGLETON',
    FetalSexAddOnDisallowedTwin: 'FETAL_SEX_ADD_ON_DISALLOWED_TWIN',
    FetalSexAddOnRequired: 'FETAL_SEX_ADD_ON_REQUIRED',
    LocationValidationErrorInhouseDisallowed: 'LOCATION_VALIDATION_ERROR_INHOUSE_DISALLOWED',
    Unknown: 'UNKNOWN'
};
/**
 * @export
 */
exports.CartErrorsValidationCodeEnum = {
    CarrierFmr1OnlyError: 'CARRIER_FMR1_ONLY_ERROR',
    CombiCddComboError: 'COMBI_CDD_COMBO_ERROR',
    CrossAssayOrder: 'CROSS_ASSAY_ORDER',
    DeprecatedTests: 'DEPRECATED_TESTS',
    DiagnosticRnaOtherRrsComboError: 'DIAGNOSTIC_RNA_OTHER_RRS_COMBO_ERROR',
    ExomeSecondaryFindingsAddOnWithoutExomeError: 'EXOME_SECONDARY_FINDINGS_ADD_ON_WITHOUT_EXOME_ERROR',
    ForbiddenProductTypesMix: 'FORBIDDEN_PRODUCT_TYPES_MIX',
    FragileXOnlyError: 'FRAGILE_X_ONLY_ERROR',
    LocationValidationError: 'LOCATION_VALIDATION_ERROR',
    LocationValidationErrorPcmRestricted: 'LOCATION_VALIDATION_ERROR_PCM_RESTRICTED',
    MissingNyApproval: 'MISSING_NY_APPROVAL',
    NipsInHouseNotEnabledError: 'NIPS_IN_HOUSE_NOT_ENABLED_ERROR',
    NotAuthenticated: 'NOT_AUTHENTICATED',
    PatientIsNotAllowedToAddTests: 'PATIENT_IS_NOT_ALLOWED_TO_ADD_TESTS',
    PreventiveCombinedWithPreventiveError: 'PREVENTIVE_COMBINED_WITH_PREVENTIVE_ERROR',
    RecurrentPregnancyLossComboError: 'RECURRENT_PREGNANCY_LOSS_COMBO_ERROR',
    RereqToUpgrade: 'REREQ_TO_UPGRADE',
    RnaUnsupportedCountryError: 'RNA_UNSUPPORTED_COUNTRY_ERROR',
    TooManyTierOnePanels: 'TOO_MANY_TIER_ONE_PANELS',
    UpgradeToRereq: 'UPGRADE_TO_REREQ',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the CartErrors interface.
 */
function instanceOfCartErrors(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCartErrors = instanceOfCartErrors;
function CartErrorsFromJSON(json) {
    return CartErrorsFromJSONTyped(json, false);
}
exports.CartErrorsFromJSON = CartErrorsFromJSON;
function CartErrorsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'replacementConcepts': !(0, runtime_1.exists)(json, 'replacementConcepts') ? undefined : json['replacementConcepts'],
        'errorMessage': !(0, runtime_1.exists)(json, 'errorMessage') ? undefined : json['errorMessage'],
        'errorSubTypes': !(0, runtime_1.exists)(json, 'errorSubTypes') ? undefined : json['errorSubTypes'],
        'validationCode': !(0, runtime_1.exists)(json, 'validationCode') ? undefined : json['validationCode'],
        'invalidTestNames': !(0, runtime_1.exists)(json, 'invalidTestNames') ? undefined : json['invalidTestNames'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
    };
}
exports.CartErrorsFromJSONTyped = CartErrorsFromJSONTyped;
function CartErrorsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'replacementConcepts': value.replacementConcepts,
        'errorMessage': value.errorMessage,
        'errorSubTypes': value.errorSubTypes,
        'validationCode': value.validationCode,
        'invalidTestNames': value.invalidTestNames,
        'country': value.country,
    };
}
exports.CartErrorsToJSON = CartErrorsToJSON;
